<template>
  <div class="hello">

    <b-container>
        <b-row style="margin-top:20px">
            <b-col>
                <h4>Receivables</h4>
            </b-col>
        </b-row>

        <!-- Total receivables -->
        <b-row>
            <b-col>
                <h4 style="color:green">Total Receivables = ${{getTotalRx.toFixed(2)}}</h4>
            </b-col>
        </b-row>

        <!-- Refundable deposit -->
        <b-row>
            <b-col>
                <h4 style="color:red">Keg Deposits Due = ${{getTotalRefundable.toFixed(2)}}</h4>
            </b-col>
        </b-row>

        <!-- Orders table -->
        <table class="table table-bordered" style="margin-top:10px">
                <thead class="thead-dark">
                    <tr>
                        <th><small>Order Number</small></th>
                        <th><small>Date</small></th>
                        <th><small>Buyer</small></th>
                        <th><small>Cost</small></th>
                        <th><small>Refundable Deposit</small></th>
                        <th><small>Refunds</small></th>
                        <th><small>Transaction Fees</small></th>
                        <th><small>Receivables</small></th>
                        <th><small>Paid?</small></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="item in breweryConsumerOrders">

                        <!-- Table of orders -->
                        <tr :key="item + item.mainorderid">
                            <td>
                                <b-button @click="showConsumerPO(item)">{{item.mainorderid}}</b-button>
                            </td>
                            <td>{{item.date}}</td>
                            <td>{{item.pub}}</td>
                            <td>${{item.totalCost.toFixed(2)}}</td>
                            <!-- Mark deposit in red if refund<deposit -->
                            <td v-if="parseFloat(item.kegDeposit)>getTotalRefunds(item).toFixed(2)" style="color:red">${{item.kegDeposit}}</td>
                            <td v-else>${{item.kegDeposit}}</td>
                            <td v-if="item.kegDeposit>0&&item.depositRefunded==1">YES</td>
                            <td>${{getTotalRefunds(item).toFixed(2)}}</td>
                            <td>${{getTransactionFees(item).toFixed(2)}}</td>
                            <td>${{getFinalRx(item).toFixed(2)}}</td>
                            <td v-if="item.paidOut==1">Yes</td>
                            <td v-else>No</td>
                        </tr>
                    </template>
                </tbody>
            </table>
            
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import Refund from './Refund'
import { consumerOrdersCollection } from '../../firebaseConfig'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'breweryConsumerOrders']),

        //Total money due to brewery
        getTotalRx(){
            var totalRx = 0
            for (var i=0; i<this.breweryConsumerOrders.length; i++){
                if(this.breweryConsumerOrders[i].paidOut!==1) totalRx = totalRx + this.getFinalRx(this.breweryConsumerOrders[i])
            }
            return totalRx
        },
        //Amount the brewery should refund. 
        getTotalRefundable(){
            var totalRf = 0
            for (var i=0; i<this.breweryConsumerOrders.length; i++){
                //Check if there's a keg deposit
                if(parseFloat(this.breweryConsumerOrders[i].kegDeposit)>0){
                    //Check if refunds are less than deposit
                    if(this.getTotalRefunds(this.breweryConsumerOrders[i])<parseFloat(this.breweryConsumerOrders[i].kegDeposit)){
                        totalRf = totalRf + parseFloat(this.breweryConsumerOrders[i].kegDeposit)
                    }

                }
            }

            return totalRf
        },
        

    },

    components: {
        Refund,
    },

    data() {
        return {

        }
    },

    methods:{

        //Show the PO with order details
        showConsumerPO(ordersObject){
                this.$router.push({ path: 'consumerpo', query: { ordersObject: ordersObject}})
        },

        //Transaction fees or order
        getTransactionFees(order){
            var fees = parseFloat(order.totalCost) * 0.0299 + 0.30
            return fees
        },

        //Final receivables
        getFinalRx(order){
            var finalRx = parseFloat(order.totalCost) - this.getTotalRefunds(order) - this.getTransactionFees(order)
            return finalRx
        },

        //Calculate total refunds for each order
        getTotalRefunds(order){
            var totalRefunds = 0
            if ('refunds' in order){
                for (var i=0; i<order.refunds.length; i ++){
                    var thisRefund = order.refunds[i]
                    if ('totalrefund' in thisRefund){
                        totalRefunds = totalRefunds + parseFloat(thisRefund.totalrefund)
                    } 
                }
            }
            return totalRefunds
        },
    },

    mounted(){
    },
}
</script>

